module.exports = __webpack_public_path__ + "static/media/danger.6125846e.svg";